"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkToolbarPopup = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const BasicButton_1 = require("@jsonjoy.com/ui/lib/2-inline-block/BasicButton");
const BasicButtonDelete_1 = require("@jsonjoy.com/ui/lib/2-inline-block/BasicButton/BasicButtonDelete");
const CopyButton_1 = require("@jsonjoy.com/ui/lib/2-inline-block/CopyButton");
const Input_1 = require("@jsonjoy.com/ui/lib/2-inline-block/Input");
const BasicTooltip_1 = require("@jsonjoy.com/ui/lib/4-card/BasicTooltip");
const Iconista_1 = require("@jsonjoy.com/ui/lib/icons/Iconista");
const EditorContextPopup_1 = require("../../chrome/EditorContextPopup");
const context_1 = require("./context");
const inputRowClass = (0, nano_theme_1.rule)({
    d: 'flex',
    fld: 'column',
    gap: '10px',
});
const actionRowClass = (0, nano_theme_1.rule)({
    d: 'flex',
    ai: 'center',
    jc: 'space-between',
    gap: '8px',
});
const actionButtonsClass = (0, nano_theme_1.rule)({
    d: 'flex',
    ai: 'center',
    gap: '6px',
});
const preventMouseDown = (event) => {
    event.preventDefault();
};
const stopMouseDownPropagation = (event) => {
    event.stopPropagation();
};
const LinkToolbarPopup = () => {
    const state = (0, context_1.useLinkButton)();
    const activeLink = state.activeLink.use();
    const draft = state.draft.use();
    const open = state.open.use();
    const normalizedDraft = state.normalizedDraft.use();
    const title = activeLink ? 'Edit link' : 'Add link';
    const subtitle = activeLink
        ? 'Update the current link target, copy it, open it, or remove it.'
        : 'Enter a URL to wrap the current selection.';
    const actionRow = activeLink ? (React.createElement("div", { className: actionRowClass, onMouseDown: stopMouseDownPropagation /* prevent popup from closing when clicking action buttons */ },
        React.createElement("div", { className: actionButtonsClass },
            React.createElement(CopyButton_1.CopyButton, { type: "button", width: 32, height: 32, rounder: true, onMouseDown: preventMouseDown, onCopy: () => activeLink.href, tooltip: { nowrap: true, renderTooltip: () => 'Copy link' } }),
            React.createElement(BasicTooltip_1.BasicTooltip, { nowrap: true, renderTooltip: () => 'Open link' },
                React.createElement(BasicButton_1.BasicButton, { type: "button", width: 32, height: 32, rounder: true, onMouseDown: preventMouseDown, to: activeLink.href },
                    React.createElement(Iconista_1.Iconista, { set: 'lucide', icon: 'external-link', width: 16, height: 16 }))),
            React.createElement(BasicTooltip_1.BasicTooltip, { nowrap: true, renderTooltip: () => 'Remove link' },
                React.createElement(BasicButtonDelete_1.BasicButtonDelete, { type: "button", width: 32, height: 32, rounder: true, onMouseDown: preventMouseDown, onConfirm: state.remove }))))) : undefined;
    return (React.createElement(EditorContextPopup_1.EditorContextPopup, { title: title, subtitle: subtitle, headerRight: actionRow, minWidth: Math.max(Math.min(560, window.innerWidth * 0.4), 320), applyDisabled: !normalizedDraft, onCancel: state.close, onApply: state.apply },
        React.createElement("div", { className: inputRowClass },
            React.createElement(Input_1.Input, { type: "text", label: "Link", value: draft, placeholder: "https://example.com", focus: true, select: open, onChange: state.setDraft, onEnter: (event) => {
                    event.preventDefault();
                    state.apply();
                }, onEsc: (event) => {
                    event.preventDefault();
                    state.close();
                } }))));
};
exports.LinkToolbarPopup = LinkToolbarPopup;
